
/* ------------------------------------------------------------------------------
 *
 *  # Bars with line
 *
 * ---------------------------------------------------------------------------- */


// Setup module
// ------------------------------

var PromanaRose = function() {


    //
    // Setup module components
    //

    // Rose chart
    var _promanaRose = function(args) {
        if (typeof echarts == 'undefined') {
            console.warn('Warning - echarts.min.js is not compiled');
            return;
        }

        var rose_element = document.getElementById(args.anchor);
        var myChart = echarts.init(rose_element);
        var option;

        option = {
            title: args.title,
            legend: args.legend,
            series: [
              {
                type: 'pie',
                radius: [50, 150],
                center: ['50%', '50%'],
                roseType: 'area',
                itemStyle: {
                  borderRadius: 8
                },
                data: args.series_data
              }
            ]
          };

        option && myChart.setOption(option);


        //
        // Resize charts
        //

        // Resize function
        var triggerChartResize = function() {
            rose_element && myChart.resize();
        };

        // On sidebar width change
        var sidebarToggle = document.querySelectorAll('.sidebar-control');
        if (sidebarToggle) {
            sidebarToggle.forEach(function(togglers) {
                togglers.addEventListener('click', triggerChartResize);
            });
        }

        // On tab change
        $('a[data-toggle="tab"]').on('shown.bs.tab', function(){
            setTimeout(function () {
                triggerChartResize();
            }, 200);
        });

        // On window resize
        var resizeCharts;
        window.addEventListener('resize', function() {
            clearTimeout(resizeCharts);
            resizeCharts = setTimeout(function () {
                triggerChartResize();
            }, 200);
        });
    };


    //
    // Return objects assigned to module
    //

    return {
        init: function(args) {
            _promanaRose(args);
        }
    }
}();
